export default "assets/images/icons/facebook-e53f15e0.svg";